import { CrowdHandlerWRState } from "../types/crowdhandler";

interface SavedEmail {
    slug: string;
    email: string;
}

interface SavedEmailResponse {
    success: boolean;
    message: string;
    email: string;
}

const session_storage_key = "crowdhandler_email_me";

const checkValidEmailAddress = (value: CrowdHandlerWRState): void => {
    if (value.email.value === null) value.email.valid = false;

    const regex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const str = value.email.value || '';
    let m;
    let valid = false;

    if ((m = regex.exec(str)) !== null) {
        m.forEach(() => {
            valid = true;
        });
    }

    value.email.valid = valid;
};

const confirmEmailTerms = (): boolean | Promise<unknown> => {
    const emailTermsDiv = document.querySelector('.ch-email-terms')?.childNodes;
    if (!emailTermsDiv) return false;

    const content: string[] = [];
    const regex = /(\s{2,})|(\r)|(\n)/g;
    const subst = ' ';

    emailTermsDiv.forEach((term) => {
        if (term.nodeType === 1) {
            const textContent = term.textContent || '';
            const result = textContent.replace(regex, subst).trim();
            if (result) {
                content.push(result);
            }
        }
    });

    if (content.length < 1) {
        return false;
    }

    if (window.confirm(content.join("\n\n"))) {
        return true;
    } else {
        return false;
    }
};

const checkPreviousEmailMeSubmission = (key: string): SavedEmailResponse => {
    let savedEmails: SavedEmail[] = [];
    const savedEmailsStr = sessionStorage.getItem(session_storage_key);

    if (savedEmailsStr) {
        try {
            savedEmails = JSON.parse(savedEmailsStr);
        } catch (error) {
            savedEmails = [];
        }
    }

    if (savedEmails.length < 1) return { success: false, message: 'No saved emails found', email: '' };

    const emailExists = savedEmails.find((email) => email.slug === key);

    if (emailExists) {
        return { success: true, message: 'Email found', email: emailExists.email };
    }
    return { success: false, message: 'No saved emails found', email: '' };
};

const saveEmailSubmissionInSessionStorage = (key: string, email: string) => {
    let savedEmails: SavedEmail[] = [];
    const savedEmailsStr = sessionStorage.getItem(session_storage_key);

    if (savedEmailsStr) {
        try {
            savedEmails = JSON.parse(savedEmailsStr);
        } catch (error) {
            savedEmails = [];
        }
    }

    let emailExists = false;

    savedEmails = savedEmails.map((saved_email) => {
        if (saved_email.slug === key) {
            saved_email.email = email;
            emailExists = true;
        }
        return saved_email;
    });

    if (!emailExists) {
        savedEmails.push({
            slug: key,
            email: email,
        });
    }

    sessionStorage.setItem(
        session_storage_key,
        JSON.stringify(savedEmails)
    );
};

export { checkValidEmailAddress, confirmEmailTerms, checkPreviousEmailMeSubmission, saveEmailSubmissionInSessionStorage };

declare global {
    interface Window {
        confirm: (message?: string) => boolean;
    }
}
